var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose12Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.831371, 1.831371)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08319985,0.234314575 C8.37158702,0.522701744 8.39377064,0.976486589 8.14975073,1.29031955 L8.08319985,1.36568542 L5.29,4.158 L7.93856437,6.80719352 C8.2509838,7.11961295 8.2509838,7.62614493 7.93856437,7.93856437 C7.6501772,8.22695154 7.19639235,8.24913517 6.88255939,8.00511525 L6.80719352,7.93856437 L4.158,5.29 L1.36568542,8.08319985 C1.05326599,8.39561928 0.546734008,8.39561928 0.234314575,8.08319985 C-0.0540725942,7.79481268 -0.0762562227,7.34102783 0.16776369,7.02719487 L0.234314575,6.951829 L3.027,4.158 L0.378950053,1.5103209 C0.0665306196,1.19790147 0.0665306196,0.691369486 0.378950053,0.378950053 C0.667337222,0.0905628837 1.12112207,0.0683792553 1.43495503,0.312399168 L1.5103209,0.378950053 L4.158,3.027 L6.951829,0.234314575 C7.26424843,-0.0781048584 7.77078041,-0.0781048584 8.08319985,0.234314575 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose12Px);
export default __webpack_public_path__ + "static/media/close_12px.dc4d1768.svg";
export { ForwardRef as ReactComponent };